import { MeasurementPlan, MeasurementVariant, Position } from '../../shared/types/protocol.ts';
import { ProtocolDraft } from '../types/sharedTypeImpl.ts';


export function defaultMeasurementVariants(protocol: ProtocolDraft): MeasurementVariant[] {
    const variantNames = ['CM', 'A', 'B', 'C'];

    const positions = [...protocol.positions];
    const defaultVariant = variantNames.map((variantName) => ({
        name: variantName,
        positions: Object.fromEntries(
            positions.map((position) => [
                position.id,
                getDefaultCount(variantName),
            ])
        ) as Record<number, number>
    }));

    return defaultVariant;
}

export function addMeasurementPlanPos(
    measurementPlan: MeasurementPlan,
    position: Position,
): MeasurementPlan {
    const newMeasurementPlan = structuredClone(measurementPlan);
    for (const variant of newMeasurementPlan.variants) {
        variant.positions[position.id] = getDefaultCount(variant.name);
    }
    return newMeasurementPlan;
}

export function removeMeasurementPlanPos(
    measurementPlan: MeasurementPlan,
    positionId: number,
): MeasurementPlan {
    const newMeasurementPlan = structuredClone(measurementPlan);
    for (const variant of newMeasurementPlan.variants) {
        delete variant.positions[positionId];
    }
    return newMeasurementPlan;
}

function getDefaultCount(variantName: string): number {
    switch (variantName) {
        case 'CM':
        case 'A':
            return 1;
        case 'B':
        case 'C':
            return 0;
        default:
            return 0;
    }
}
